import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import config from '../../config';
import { useWindowSize } from '../../helpers/hooks/useWindowSize';
import LoadRemoteComponent from '../LoadRemoteComponent/LoadRemoteComponent';

const BrandingWrapper = (props) => {
  const { isMobile } = useWindowSize();

  // don't show branding on the health page
  return !!useRouteMatch('/client-side-health') ? (
    props.children
  ) : (
    <>
      <div style={{ height: isMobile ? '75px' : '100px' }}>
        <LoadRemoteComponent
          url={config.brandingUrl}
          name="branding"
          props={{ enablePodRedirection: false, enableStickyNav: true }}
        >
          {null}
        </LoadRemoteComponent>
      </div>
      {props.children}
      <LoadRemoteComponent url={config.footerUrl} name="footer">
        {null}
      </LoadRemoteComponent>
    </>
  );
};

export default BrandingWrapper;
